<!-- Title -->
<Label class="title">{{title}}</Label>
<div style="margin-top:15px;margin-left:10px;">{{subtitle}}</div>
<!-- Loading Spinner -->
<img class="progress-spinner rotate" *ngIf="loading" src="assets/loading.png" alt="loading...">
<!-- Main Chart Area -->
<figure id="d3circles" #view style="width:59vmin;height:59vmin;margin-left:auto;margin-right:auto"
        (window:resize)="onResize()"></figure>
